import React from "react";

interface AddProps {
  className?: string;
  width?: number;
  fill?: string;
  height?: number;
  onClick?: () => void;
}
const Iconbag: React.FC<AddProps> = ({ width, height }) => (
  <svg width="27" height="32.063" viewBox="0 0 27 32.063" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3.657 30.937q-1.161 0-1.986-.827a2.7 2.7 0 0 1-.827-1.984V11.25q0-1.161.827-1.986.825-.827 1.986-.827h2.812q0-2.917 2.058-4.974Q10.58 1.405 13.5 1.405t4.974 2.058 2.058 4.974h2.812q1.161 0 1.986.827.827.825.827 1.986v16.875q0 1.16-.827 1.986-.825.827-1.986.827zm0-2.812h19.687V11.25H3.657zm9.843-8.437q2.917 0 4.974-2.057t2.058-4.974h-2.813q0 1.759-1.232 2.987a4.05 4.05 0 0 1-2.987 1.231 4.05 4.05 0 0 1-2.987-1.232 4.05 4.05 0 0 1-1.231-2.986H6.468q0 2.917 2.058 4.974 2.054 2.058 4.974 2.057M9.282 8.438h8.438q0-1.759-1.232-2.987A4.05 4.05 0 0 0 13.5 4.219a4.05 4.05 0 0 0-2.987 1.232 4.05 4.05 0 0 0-1.231 2.986"
      fill="#1C1B1F"
    />
  </svg>
);
export default Iconbag;
